import { FaUserCog } from 'react-icons/fa'
import { ImFolderUpload } from 'react-icons/im';
import { RiDashboardFill, RiBarChart2Fill } from 'react-icons/ri';
import { FaUserInjured, FaUserMd, FaDiagnoses } from 'react-icons/fa';

export const Icons = {
  dashboard: RiDashboardFill,
  diagnostics: FaDiagnoses,
  doctor: FaUserMd,
  patient: FaUserInjured,
  report: RiBarChart2Fill,
  upload: ImFolderUpload,
  userManagement: FaUserCog
};
